import AlSelectizeController from './controller';
import templateUrl from './component.tpl.html';

angular
    .module('festzelt-os.modules.core')
    .component(
        'alSelectize',
        {
            controller: AlSelectizeController,
            controllerAs: 'vm',
            templateUrl,
            bindings: {
                model: '<',
                disabled: '<',
                items: '<',
                selectizeOptions: '<',
                onChange: '&'
            }
        }
    );



// WEBPACK FOOTER //
// ./src/app/modules/core/components/al-selectize/component.js